import { Provider as ChakraProvider } from '@ionq/legacy-ui';
import type { ComponentProps, ReactNode } from 'react';

type Props = {
    system: ComponentProps<typeof ChakraProvider>['value'];
    children: ReactNode;
};

/**
 * The app's Chakra provider. Color mode follows the user's stored choice
 * (next-themes `theme`: light, dark or system, default system); the pre-paint
 * public/theme-init.js applies the same decision before React mounts.
 */
export function AppChakraProvider({ system, children }: Props) {
    return (
        <ChakraProvider value={system} enableSystem enableColorScheme>
            {children}
        </ChakraProvider>
    );
}
